exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setUp[data-v-19f557cd] .ivu-tabs-nav-scroll{padding:0 30px}.setUp[data-v-19f557cd] .ivu-tabs-nav .ivu-tabs-tab{padding:8px 45px}", ""]);

// exports
